import { PRODUCT_PRICE_MAX } from '../constants/product';

const completeProductPricePattern = /^\d+(?:[.,]\d{1,2})?$/;
const partialProductPricePattern = /^\d*(?:[.,]\d{0,2})?$/;

const normalizeProductPrice = (value: string) => value.replace(',', '.');

export const parseProductPrice = (value: string): number | null => {
  const trimmedValue = value.trim();
  if (!completeProductPricePattern.test(trimmedValue)) {
    return null;
  }

  const parsedValue = Number(normalizeProductPrice(trimmedValue));
  if (!Number.isFinite(parsedValue) || parsedValue <= 0 || parsedValue > PRODUCT_PRICE_MAX) {
    return null;
  }

  return parsedValue;
};

export const isProductPriceInputAllowed = (value: string): boolean => {
  if (value === '') {
    return true;
  }

  if (!partialProductPricePattern.test(value)) {
    return false;
  }

  const parsedValue = Number(normalizeProductPrice(value));
  return Number.isFinite(parsedValue) && parsedValue <= PRODUCT_PRICE_MAX;
};
